import { render, staticRenderFns } from "./email-verification-verified.html?vue&type=template&id=2d1399d1&scoped=true&"
import script from "./email-verification-verified.js?vue&type=script&lang=js&"
export * from "./email-verification-verified.js?vue&type=script&lang=js&"
import style0 from "./email-verification-verified.scss?vue&type=style&index=0&id=2d1399d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1399d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
